import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#37A1E8', // Azul corporativo
                secondary: '#A7A8AC', // Gris corporativo
                accent: '#37A1E8', // Azul para acentos
                error: '#FF5252',
                info: '#37A1E8',
                success: '#4CAF50',
                warning: '#FFC107',
                background: '#FEFEFE',
                surface: '#FEFEFE',
            },
        },
    },
});
